import React, { useState, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import NewsItem from '@/components/blog/NewsItem'
import Meta from '@/components/Meta'
import { FileProvider } from '../../lib/files'
import { IData } from '@/components/blogImg/types'
import Config from '../../site.config'
import { Search } from '@/components/search'
import { PrimitiveButton } from '@/components/primitive'
import { IMetadata } from '@/components/blogImg/types'
import { PageTitle } from '@/components/title'

interface IProps {
  data: IData[]
}

const Blog = (props: IProps) => {
  const { data } = props
  const [searchItem, setSearchItem] = useState('')
  const [showItems, setShowItems] = useState(4)
  const [showLessBtn, setShowLessBtn] = useState(false)

  const strContains = (item: IMetadata, filter: string) => {
    const description = new String(item.description).toLowerCase()
    const title = new String(item.title).toLowerCase()
    const titleOK = title.includes(filter.toLowerCase())
    const descOK = description.includes(filter.toLowerCase())
    return (descOK || titleOK) && !item.draft
  }

  const filteredData = searchItem
    ? data.filter((item) => {
        return strContains(item.metadata, searchItem)
      })
    : data.filter((item) => !item.metadata.draft)

  const blogData = searchItem ? filteredData : data

  const handleLoadMore = () => {
    if (blogData.length <= showItems + 4) {
      setShowLessBtn(true)
    }
    setShowItems(showItems + 4)
  }

  const handleShowLess = () => {
    if (showItems > 4) {
      setShowItems(showItems - 4)
      setShowLessBtn(false)
    }
  }

  // Ordenar los datos por fecha en orden descendente
  const sortedData = blogData.sort((a, b) => {
    const dateA = new Date(a.metadata.date).getTime()
    const dateB = new Date(b.metadata.date).getTime()
    return dateB - dateA
  })

  const displayedData = sortedData.filter((item) => !item.metadata.draft)

  return (
    <>
      <Meta title='Blog' />
      <NextSeo
        title='Romikya Labs'
        description={Config.site.description}
        openGraph={{
          url: Config.site.URL,
          title: Config.site.title,
          description: Config.site.description,
          images: [
            {
              url: Config.site.preview,
              width: 424,
              height: 392,
              alt: 'banner',
              type: 'image/png',
            },
          ],
          site_name: 'Romikya Labs',
        }}
      />
      {/* <!-- Blog --> */}
      <section className='pt-[5.5rem]'>
        <div className='relative mx-auto top-12 max-w-lg text-center'>
          <h1 className='font-display text-jacarta-700 mb-4 text-2xl dark:text-white sm:text-5xl'>
            Nuestras publicaciones
          </h1>
        </div>
        <div className='py-16 md:py-24'>
          <Search
            value={searchItem}
            placeHolder={'Buscar artículo'}
            onChangeHandler={(e) => setSearchItem(e.target.value)}
            onClickHandler={() => setSearchItem('')}
          />

          <div className='lay'>
            {/* <!-- Featured Post --> */}
            <NewsItem data={displayedData.slice(0, showItems)} />

            {/* <!-- Load More --> */}
            {displayedData.length > 4 && !showLessBtn && (
              <div className='mt-10 text-center'>
                <PrimitiveButton onClick={handleLoadMore} dark={true}>
                  Mostrar más
                </PrimitiveButton>
              </div>
            )}

            {/* <!-- Show Less --> */}
            {showItems > 4 && (
              <div className='mt-10 text-center'>
                <PrimitiveButton onClick={handleShowLess} dark={true}>
                  Mostrar menos
                </PrimitiveButton>
              </div>
            )}
          </div>
        </div>
      </section>
      {/* <!-- end blog --> */}
    </>
  )
}

export default Blog

export async function getStaticProps() {
  const provider = new FileProvider()
  const data = provider.getPosts()
  const filteredData = data.filter((item) => item.metadata.draft !== true)

  return {
    props: {
      data: filteredData,
    },
  }
}
